export default __webpack_public_path__ + "static/media/90a14b24-d405-40d2-9de6-b93cf98de371.9b636d94.jpeg";